import api from './api';

export interface Varsis2Dto {
  nint?: number;
  impuestotasa1?: number | null;
  impuestotasa2?: number | null;
  impuestotasa3?: number | null;
  impuestotasa4?: number | null;
  [key: string]: unknown;
}

const DEFAULT_TASAS = [21, 10.5, 27, 0];

const variablesSistemaService = {
  getVariablesSistema: async (): Promise<Varsis2Dto[]> => {
    try {
      const resp = await api.get<Varsis2Dto[]>('/api/VariablesSistema');
      const raw = resp?.data;
      const items: Varsis2Dto[] = Array.isArray(raw) ? raw : Array.isArray((raw as any)?.items) ? (raw as any).items : [];
      return items;
    } catch (error) {
      console.error('Error al obtener variables del sistema:', error);
      return [];
    }
  },

  /** Obtiene las tasas de IVA (IMPUESTOTASA1-4) como array [tasa1, tasa2, tasa3, tasa4] */
  getTasasIva: async (): Promise<number[]> => {
    const items = await variablesSistemaService.getVariablesSistema();
    const first = items[0];
    if (!first) return DEFAULT_TASAS;

    const t1 = first.impuestotasa1 != null ? Number(first.impuestotasa1) : DEFAULT_TASAS[0];
    const t2 = first.impuestotasa2 != null ? Number(first.impuestotasa2) : DEFAULT_TASAS[1];
    const t3 = first.impuestotasa3 != null ? Number(first.impuestotasa3) : DEFAULT_TASAS[2];
    const t4 = first.impuestotasa4 != null ? Number(first.impuestotasa4) : DEFAULT_TASAS[3];

    return [t1, t2, t3, t4];
  },

  /** Retorna objeto con impuestotasa1-4 para FacturaCompraDetalle y otros */
  getImpuestoTasas: async (): Promise<{ impuestotasa1?: number; impuestotasa2?: number; impuestotasa3?: number; impuestotasa4?: number }> => {
    const arr = await variablesSistemaService.getTasasIva();
    return {
      impuestotasa1: arr[0],
      impuestotasa2: arr[1],
      impuestotasa3: arr[2],
      impuestotasa4: arr[3]
    };
  }
};

export default variablesSistemaService;
